import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';

import { getDashboardCompletedPeriodListUI, getDashboardCompletedPeriodTabs } from '../../../../../../redux/selectors';
import {
  chartViewUnits,
  detailsRanges,
  getPeriodList,
  changeDetails,
} from '../../../../../../redux/dashboard-completed';

import CustomTooltip from './Tooltip';

import './styles.css';

// component

class DashboardCompletedChart extends Component {
  componentDidMount() {
    this.props.dispatch(getPeriodList());
  }

  _changeComparativeRange = (periodTab) => {
    if (!periodTab) return; // Verifica se encontrou o period clicado no gráfico.
    const { rangeId, initialReferenceDate, finalReferenceDate } = periodTab;
    this.props.dispatch(changeDetails(rangeId, moment(initialReferenceDate).format('YYYY-MM-DD'), moment(finalReferenceDate).format('YYYY-MM-DD')));
  }

  _clickBar = (data) => {
    this._changeComparativeRange(this.props.periodTabs.filter(tab => moment(data.activePayload[0].payload.date).isBetween(moment(tab.initialReferenceDate), moment(tab.finalReferenceDate), null, '[]'))[0]);
  }

  _getAxisLabel = () => {
    switch (this.props.viewUnit) {
      case chartViewUnits.QTY:
        return 'Quantidade de NFs';
      case chartViewUnits.WEIGHT:
        return 'Peso transportado';
      default: // case chartViewUnits.VALUE:
        return 'Vendas no período';
    }
  }

  _getChartData = () => {
    const { viewUnit, data, range } = this.props;

    const unit = {
      [chartViewUnits.QTY]: 'Qty',
      [chartViewUnits.WEIGHT]: 'Weight',
      [chartViewUnits.VALUE]: 'Value',
    }[viewUnit];

    const rangeProp = range === detailsRanges.WEEK ? 'week' : 'month';

    return data.map((item) => {
      const lateValue = item[`late${unit}`];
      const onTimeValue = item[`onTime${unit}`];
      const totalValue = lateValue + onTimeValue;

      return {
        name: moment(item.referenceDate).format('DD/MM'),
        date: item.referenceDate,
        rangeId: `${rangeProp === 'week' ? moment(item.referenceDate).format('wwgggg') : moment(item.referenceDate).format('MMYYYY')}`,
        viewUnit,
        lateValue,
        onTimeValue,
        totalValue,
        lateValuePc: totalValue ? lateValue / totalValue : 0,
        onTimeValuePc: totalValue ? onTimeValue / totalValue : 0,
      };
    });
  }

  _getFormater = () => {
    const { viewUnit, isRelative, intl } = this.props;

    if (isRelative) {
      return v => intl.formatNumber(v, {
        style: 'percent',
        maximumFractionDigits: 0,
      });
    }

    switch (viewUnit) {
      case chartViewUnits.QTY:
        return v => intl.formatNumber(v);
      case chartViewUnits.WEIGHT:
        return v => `${intl.formatNumber(v / 1000)}t`;
      default: // case chartViewUnits.VALUE:
        return v => `${intl.formatNumber(v / 1000)}m`;
    }
  }

  _drawBar = ({
    fill,
    x,
    y,
    width,
    height,
    payload,
  }) => {
    const opacity = payload.rangeId === this.props.currentRangeId ? 1 : 0.4;

    return (
      <rect
        fill={fill}
        x={x}
        y={y}
        width={width}
        height={height}
        opacity={opacity}
      />
    );
  }

  render() {
    const {
      className, isRelative, isLoading
    } = this.props;

    if (!isLoading) {
      return (
        <div className={`DashboardCompletedChart ${className || ''}`}>
          <h5 className="DashboardCompletedChart__title">{this._getAxisLabel()}</h5>
          <div className="DashboardCompletedChart__container">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={this._getChartData()}
                barGap={4}
                margin={{
                  top: 4,
                  right: 0,
                  bottom: 4,
                  left: 0,
                }}
                onClick={this._clickBar}
              >
                <CartesianGrid
                  strokeDasharray="2 2"
                  stroke="#e0e0e0"
                  vertical={false}
                />
                <XAxis
                  dataKey="name"
                  strokeDasharray="2 2"
                  stroke="#e0e0e0"
                  tickLine={false}
                />
                <YAxis
                  width={0}
                  axisLine={false}
                  tickLine={false}
                  tickFormatter={this._getFormater()}
                />
                <Tooltip
                  content={<CustomTooltip />}
                />
                <Bar
                  dataKey={isRelative ? 'lateValuePc' : 'lateValue'}
                  stackId="day1"
                  fill="#EB6565"
                  shape={this._drawBar}
                />
                <Bar
                  dataKey={isRelative ? 'onTimeValuePc' : 'onTimeValue'}
                  stackId="day1"
                  fill="#21C756"
                  shape={this._drawBar}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      );
    }

    return null;
  }
}

// redux

const mapStateToProps = state => ({
  range: state.dashboardCompleted.details.range,
  currentRangeId: state.dashboardCompleted.details.currentRangeId,
  data: state.dashboardCompleted.periodList.list,
  ui: getDashboardCompletedPeriodListUI(state),
  viewUnit: state.dashboardCompleted.chartOptions.viewUnit,
  isRelative: state.dashboardCompleted.chartOptions.isRelative,
  periodTabs: getDashboardCompletedPeriodTabs(state),
});

export default connect(mapStateToProps)(injectIntl(DashboardCompletedChart));
